<div *transloco="let t" class=" h-dvh lg:h-screen overflow-hidden flex flex-col justify-center w-full">
  <form #signupForm="ngForm" class="flex flex-col gap-6 max-w-[1366px] w-full p-5 m-auto overflow-auto hide-scrollbar">
    <div class="w-full flex justify-center">
      <img src="logo.png" class="logo !h-20" />
    </div>
    <div class="w-full flex gap-3 justify-center">
      <button class="text-xl w-56"
              [class.primary]="current() === 'ARTIST'"
              [class.light]="current() !== 'ARTIST'"
              (click)="current.set('ARTIST')">
        <wun-pencil-rule-icon wunIcon />
        {{'signup.ARTIST' | transloco}}

      </button>
      <button class="text-xl w-56"
              (click)="current.set('COLLECTOR')"
              [class.primary]="current() === 'COLLECTOR'"
              [class.light]="current() !== 'COLLECTOR'">
        <wun-picture-icon wunIcon />
        {{'signup.COLLECTOR' | transloco}}
      </button>
      <button class="text-xl w-56"
              (click)="current.set('GALLERY')"
              [class.primary]="current() === 'GALLERY'"
              [class.light]="current() !== 'GALLERY'">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
          <path stroke-linecap="round" stroke-linejoin="round" d="m2.25 12 8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25" />
        </svg>



        {{'signup.GALLERY' | transloco}}
      </button>
    </div>
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 p-0 lg:px-10 pb-0">
      <div wunInputContainer>
        <label>{{ 'common.name' | transloco }}</label>
        <input required ngModel name="firstName" wunInput black>
      </div>
      <div wunInputContainer>
        <label>{{ 'common.surname' | transloco }}</label>
        <input required ngModel name="lastName" wunInput black>
      </div>
      <div wunInputContainer>
        <label>{{ 'common.email' | transloco }}</label>
        <input required ngModel name="email" email wunInput black>
      </div>
      <div wunInputContainer>
        <label>{{ 'common.country' | transloco }}</label>
        <input required ngModel name="country" wunInput black>
      </div>
      <div wunInputContainer>
        <label>{{ 'common.city' | transloco }}</label>
        <input required ngModel name="city" wunInput black>
      </div>
      <div wunInputContainer>
        <label>{{ 'common.birthDate' | transloco }}</label>
        <input required ngModel name="birthday" [max]="this.maxDate" type="date" wunInput black>

      </div>
      <div wunInputContainer>
        <label>{{ 'common.profileType' | transloco }}</label>
        <select required ngModel name="profileType" class="h-[34px]" wunInput black>
          <option value="">{{'common.select' | transloco}}</option>
          <option value="private">{{'common.private' | transloco}}</option>
          <option value="company">{{'common.company' | transloco}}</option>
        </select>
      </div>
      @if(signupForm.value?.profileType === 'company') {
        <div wunInputContainer>
          <label>{{ 'common.businessName' | transloco }}</label>
          <input required ngModel name="businessName" wunInput black>
        </div>
        <div wunInputContainer>
          <label>{{ 'common.vatNumber' | transloco }}</label>
          <input required ngModel name="vatNumber" wunInput black>
        </div>
      } @else {
        <div class="hidden lg:block"></div>
        <div class="hidden lg:block"></div>
      }
    </div>
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:px-10 pb-0">
      <div wunInputContainer>
        <label>{{ 'common.password' | transloco }}</label>
        <input type="password" required ngModel name="password" wunInput black>
      </div>
      <div wunInputContainer>
        <label>{{ 'common.confirmPassword' | transloco }}</label>
        <input type="password" required ngModel name="confirmPassword" wunInput black>
      </div>
      <div class="w-full flex justify-end items-end">
        <button wunButton primary class="w-full !h-12" (click)="signup()">{{'common.signup' | transloco}}</button>
      </div>
    </div>

    <div class="lg:px-10 text-2xl gap-4 flex flex-col">
      <div class="flex gap-4 items-center">
        <wun-checkbox [value]="true" ngModel name="termsAndConditions" [label]="t('signup.termsAndConditions')" /> <a href="/terms-and-conditions.pdf" target="_blank">({{t('common.read')}})</a>
      </div>
      <div class="flex gap-4 items-center">
        <wun-checkbox [value]="true" ngModel name="privacyPolicy" [label]="t('signup.privacyPolicy')" /> <a href="/privacy-policy.pdf" target="_blank">({{t('common.read')}})</a>
      </div>
      <div class="flex gap-4 items-center">
        <wun-checkbox [value]="true" ngModel name="signDocument" [label]="t('signup.signDocument')" /> <a href="/contract.docx" target="_blank">({{t('common.read')}})</a>
      </div>
    </div>


  </form>
</div>

